import type { Bucket } from '../../../stores/JobApplicationStore/types';
import { BUCKET_QUERY_PARAM_KEY } from '../queryParams';

import { getQueryFromBucket } from './BucketQueryParam';

const updateBucketAndRefreshPage = (bucket: Bucket) => {
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;

  const bucketQueryString = getQueryFromBucket(bucket);
  if (bucketQueryString) {
    searchParams.set(BUCKET_QUERY_PARAM_KEY, bucketQueryString);
  } else {
    searchParams.delete(BUCKET_QUERY_PARAM_KEY);
  }

  window.location.search = searchParams.toString();
};

export default updateBucketAndRefreshPage;
